export const DELETE_ACCOUNT_CODE_URL = 'p/auth/v1/deleteAccount';
export const GET_VERIFICATION_CODE_URL = 'p/auth/v1/login';
export const GET_VERIFICATION_CODE_FOREIGN_URL = 'p/auth/v2/login';
export const GET_VERIFY_CODE_URL = 'p/auth/v1/verify';
export const GET_VERIFY_CODE_FOREIGN_URL = 'p/auth/v2/verify';
export const GET_LOGIN_WITH_GOOGLE_URL = 'p/auth/v1/social';

export const LOGIN_STATE = 'LOGIN_STATE';
export const LOGOUT_STATE = 'LOGOUT_STATE';
